import React, { useEffect, useRef, useState } from "react"
import moment from "moment-timezone"

import useToast from "./hooks/useToast"
import useModal from "./hooks/usePopup"
import useTrackingCode from "./hooks/useTrackingCode"

import EventFooter from "./components/EventFooter"
import EventHeader from "./components/EventHeader"
import EventButton from "./components/EventButton"
import PhoneNumberForm from "./components/PhoneNumberForm"

import Toast from "./components/Toast"
import Modal from "./components/Modal"

import translations from "./utils/translations"

import { getApiResponse, sendApiRequest, sendMessageToNativeApp } from "./utils/nativeUtils"
import RefreshButton from "./components/RefreshButton"

import "./App.scss"
import EventButtonTop from "./components/EventButtonTop"
import EventHeaderLikeBoard from "./components/EventLikeBoard"
import EventHeaderFeedBoard from "./components/EventFeed"
import Indicator from "./components/Indicator"
import applyButton from "./assets/images/applyButton.png"
import applyButtonDeactive from "./assets/images/applyButtonDeactive.png"

const ERROR_TYPE = {
    INVALID_EVENT_TIME: "10001",
    NOT_ENOUGH_POINT: "10002",
    ALREADY_PURCHASE_PRODUCT: "10005",
}
const imageUrls = [applyButton, applyButtonDeactive]
function App() {
    const { toast, showToast, hideToast } = useToast()
    const { modal, showModal, hideModal } = useModal()
    const { setAppsflyerTrackingCode } = useTrackingCode()

    const [profile, setProfile] = useState(null)
    //FIXME - temp value
    // const [profile, setProfile] = useState({
    //     "profileId": 5784,
    //     "nickname": "test8",
    //     "likeGivenCount": 1,
    //     "likeTakenCount": 1,
    //     "point": 10,
    //     "sendYn": "N",
    //     "remark": null, //NANO, BOT 제외, //직원
    //     "profileRegisterDateTime": "2023-05-26T03:54:59"
    // })

    // {
    //     "profileId": 5784,
    //     "nickname": "test8",
    //     "remark": null,
    //     "profileRegisterDateTime": "2023-05-26T03:54:59",
    //     "likeGivenCount": 1,
    //     "likeTakenCount": 2,
    //     "point": 100.0,
    //     "sendYn": "Y"
    // }

    const [isPurchased, setIsPurchased] = useState(false)
    const [isStart, setIsStart] = useState(true)

    const [isSuccessModalVisible, setSuccessModalVisible] = useState(false)
    const [isFailModalVisible, setIsFailModalVisible] = useState(false)
    const [isInnerModalVisible, setIsInnerModalVisible] = useState(false)

    const [isLoginModalVisible, setIsLoginModalVisible] = useState(false)
    const [isAfterRegistedVisible, setIsAfterRegistedVisible] = useState(false)
    const [isDuplecatedApplyVisible, setIsDuplecatedApplyVisible] = useState(false)

    const [isNoTargetModalVisible, setIsNoTargetModalVisible] = useState(false)
    const [isCheckDoneModalVisible, setIsCheckDoneModalVisible] = useState(false)
    const [isApplyModalVisible, setIsApplyModalVisible] = useState(false)
    const [isDone, setIsDone] = useState(false)
    const [imageSrc, setImageSrc] = useState(applyButton)

    const [isLoading, setIsLoading] = useState(false)

    const [loadedImages, setLoadedImages] = useState(0)

    const inputRef = useRef(null)

    function getErrorResponse(event) {
        setIsLoading(false)
        sendMessageToNativeApp("handleLog", {
            message: "getErrorResponse",
            data: event,
        })
    }

    const checkEventStartTime = () => {
        const now = moment().tz("Asia/Seoul")
        const startTime = moment.tz("2024-06-24 09:00:00", "Asia/Seoul")

        return now.isBefore(startTime)
    }

    useEffect(() => {
        imageUrls.forEach((url) => {
            const loadImage = new Image()
            loadImage.src = url
            loadImage.onload = () => {
                setLoadedImages((prev) => prev + 1)
            }
        })
    }, [])

    useEffect(() => {
        getTicket()
        window.getApiResponse = getApiResponse
        window.getErrorResponse = getErrorResponse
        return () => {
            window.getApiResponse = undefined
            window.getErrorResponse = undefined
        }
    }, [])

    function getTicket() {
        try {
            const requestObj = {
                method: "get",
                callback: function (responseData) {
                    try {
                        if (responseData?.header?.isSuccessful) {
                            if (responseData.body) {
                                setProfile({ ...responseData.body })
                            } else {
                                setProfile(null)
                            }
                            //FIXME 필요없음
                            // if (checkEventStartTime()) {
                            //     setIsStart(false)
                            //     return
                            // }
                        } else {
                            setProfile(null)
                        }
                        setIsLoading(false)
                        setAppsflyerTrackingCode(translations.TRACKING_CODE.view, {
                            profile_id: responseData?.body?.profile?.id ? responseData.body.profile.id : 0,
                        })
                        return
                    } catch (error) {
                        setIsLoading(false)
                    }
                },
            }

            if (window.Android) {
                requestObj["url"] = `/resource/v1/events/good-bye-likes`
            } else {
                requestObj["url"] = `/resource/v1/events/good-bye-likes`
            }

            sendApiRequest(requestObj)
        } catch (error) {
            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }

    // 티켓 구매 함수
    function progressApplyEvent() {
        if (isLoading) {
            return
        }
        setIsLoading(true)

        try {
            const requestObj = {
                method: "post",
                url: `/resource/v1/events/good-bye-likes`,
                callback: function (responseData) {
                    try {
                        if (responseData?.header?.isSuccessful) {
                            // 응모 성공
                            setIsCheckDoneModalVisible(true)
                            setAppsflyerTrackingCode(translations.TRACKING_CODE.refund, {
                                profile_id: profile?.id ? profile.id : 0,
                            })
                        }
                        setIsLoading(false)
                    } catch (error) {
                        setIsLoading(false)
                    }
                    return
                },
            }

            sendApiRequest(requestObj)
        } catch (error) {
            setIsLoading(false)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="event-page">
            {isLoading && <Indicator />}
            <EventHeader />
            <EventButtonTop
                profile={profile}
                showToast={showToast}
                setIsLoginModalVisible={setIsLoginModalVisible}
                setIsInnerModalVisible={setIsInnerModalVisible}
                setIsDuplecatedApplyVisible={setIsDuplecatedApplyVisible}
                setIsAfterRegistedVisible={setIsAfterRegistedVisible}
                setIsNoTargetModalVisible={setIsNoTargetModalVisible}
                setAppsflyerTrackingCode={setAppsflyerTrackingCode}
                setIsApplyModalVisible={setIsApplyModalVisible}
            />
            <EventHeaderLikeBoard
                profile={profile}
                isStart={isStart}
                isPurchased={isPurchased}
                setIsLoginModalVisible={setIsLoginModalVisible}
                setIsInnerModalVisible={setIsInnerModalVisible}
                setIsDuplecatedApplyVisible={setIsDuplecatedApplyVisible}
                setIsAfterRegistedVisible={setIsAfterRegistedVisible}
                showToast={showToast}
                setIsNoTargetModalVisible={setIsNoTargetModalVisible}
                setAppsflyerTrackingCode={setAppsflyerTrackingCode}
                setIsApplyModalVisible={setIsApplyModalVisible}
                setIsDone={setIsDone}
                isDone={isDone}
                setImageSrc={setImageSrc}
                imageSrc={imageSrc}
            />
            <EventHeaderFeedBoard showToast={showToast} />
            <EventFooter />

            <RefreshButton onClick={() => window.location.reload()} />

            {toast.isVisible && <Toast message={toast.message} onClose={hideToast} />}

            {modal.isVisible && (
                <Modal
                    title={modal.title}
                    content={modal.content}
                    buttons={[{ label: translations.BUTTON.yes, onClick: () => hideModal() }]}
                    onClose={() => hideModal()}
                />
            )}

            {/* 로그인 모달 */}
            {isLoginModalVisible && (
                <Modal
                    title={translations.MODAL.loginModalTitle}
                    content={translations.MODAL.loginModalContent}
                    buttons={[
                        {
                            label: translations.BUTTON.login,
                            onClick: () => (window.location.href = "celebe://deeplink/login"),
                        },
                    ]}
                    onClose={() => setIsLoginModalVisible(false)}
                />
            )}

            {isNoTargetModalVisible && (
                <Modal
                    title={translations.MODAL.noTargetModalTitle}
                    content={translations.MODAL.noTargetModalContent}
                    buttons={[
                        {
                            label: translations.BUTTON.qna,
                            onClick: () => {
                                setIsNoTargetModalVisible(false)
                                window.location.href = "celebe://deeplink?navigation=QNA"
                            },
                        },
                    ]}
                    onClose={() => setIsNoTargetModalVisible(false)}
                />
            )}

            {isAfterRegistedVisible && (
                <Modal
                    title={translations.MODAL.afterRegistedTitle}
                    content={translations.MODAL.afterRegistedContents}
                    buttons={[
                        {
                            label: translations.BUTTON.ok,
                            onClick: () => {
                                setIsAfterRegistedVisible(false)
                            },
                        },
                    ]}
                    onClose={() => setIsAfterRegistedVisible(false)}
                />
            )}

            {isSuccessModalVisible && (
                <Modal
                    title={translations.MODAL.successModalTitle}
                    content={translations.MODAL.successModalContent}
                    buttons={[
                        {
                            label: translations.BUTTON.ok,
                            onClick: () => {
                                setSuccessModalVisible(false)
                                window.location.reload()
                            },
                        },
                    ]}
                    onClose={() => {
                        setSuccessModalVisible(false)
                        window.location.reload()
                    }}
                />
            )}

            {isFailModalVisible && (
                <Modal
                    title={`Error occurred.`}
                    content={
                        <div>
                            <p>please try again later.</p>
                        </div>
                    }
                    buttons={[{ label: translations.BUTTON.yes, onClick: () => setIsFailModalVisible(false) }]}
                    onClose={() => setIsFailModalVisible(false)}
                />
            )}

            {isInnerModalVisible && (
                <Modal
                    title={translations.MODAL.innerModalTitle}
                    content={translations.MODAL.innerModalContent}
                    buttons={[
                        {
                            label: translations.BUTTON.ok,
                            onClick: () => {
                                setIsInnerModalVisible(false)
                            },
                        },
                    ]}
                    onClose={() => {
                        setIsInnerModalVisible(false)
                    }}
                />
            )}

            {isApplyModalVisible && (
                <Modal
                    title={translations.MODAL.applyModalTitle}
                    content={
                        <div>
                            <p>{translations.MODAL.applyModalContent}</p>
                        </div>
                    }
                    buttons={[
                        {
                            label: translations.BUTTON.refund,
                            onClick: () => {
                                progressApplyEvent()
                                setIsApplyModalVisible(false)
                                setImageSrc(applyButtonDeactive)
                                setIsDone(true)

                                // setAppsflyerTrackingCode(translations.TRACKING_CODE.complete, {
                                //     profile_id: profile?.id ? profile.id : 0,
                                //     point: profile?.point ? profile.point : 0,
                                // })
                            },
                        },
                    ]}
                    onClose={() => {
                        setIsApplyModalVisible(false)
                    }}
                />
            )}

            {isCheckDoneModalVisible && (
                <Modal
                    title={translations.MODAL.checkDoneTitle}
                    content={
                        <div>
                            <p>{translations.MODAL.checkDoneContent}</p>
                        </div>
                    }
                    buttons={[
                        {
                            label: translations.BUTTON.ok,
                            onClick: () => {
                                setIsCheckDoneModalVisible(false)
                            },
                        },
                    ]}
                    onClose={() => {
                        setIsCheckDoneModalVisible(false)
                    }}
                />
            )}
        </div>
    )
}

export default App
